module.exports = __webpack_public_path__ + "img/product-2-lanya.b4d23969.png";